import { howItWorks } from '@/mocks/home';

export default function HowItWorks() {
  return (
    <section id="how" className="scroll-mt-20 border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-16">
        <div className="max-w-2xl">
          <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">三步直达，不绕弯</h2>
          <p className="mt-3 text-sm leading-7 text-foreground-700 md:text-base">
            从打开本页到跳转开吃，中间只有三个动作，习惯一次就再也不想回头搜索。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 md:grid-cols-3">
          {howItWorks.map((step) => (
            <div
              key={step.id}
              className="relative overflow-hidden rounded-lg border border-background-200 bg-background-100/60 p-5"
            >
              <span className="pointer-events-none absolute -right-2 -top-3 font-heading text-6xl text-background-300 select-none">
                {step.index}
              </span>
              <span className="relative flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className={`${step.icon} text-xl`}></i>
              </span>
              <h3 className="relative mt-4 font-heading text-lg text-foreground-950">{step.title}</h3>
              <p className="relative mt-2 text-sm leading-6 text-foreground-600">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}